import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { SERVICE_AFFECTED } from '../form-definition/section-constants';

// MOBILE lacks an impactLevel and FIXED lacks a riskValue. Both values are used for similar things though
const fieldId = SERVICE_AFFECTED;

const initialValues = '';


const vFParams = {
  fieldTitle: 'What was affected?',
  fieldSubTitle: 'List the services affected that were not part of the original change.',
  characterLimit: 500, // don't forget to add to validator
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // Dynamically reduces charaters limit by 6 char for '<' special character.
  const specialCharCount = (values[fieldId] !== null) ? (values[fieldId].match(/</g) || '').length : 0;
  vFParams.characterLimit = 500;
  if (specialCharCount > 0) {
    vFParams.characterLimit -= (specialCharCount * 6);
  }

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please provide details' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const whatWasAffected = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { whatWasAffected };
